import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  DeleteBidReportMutation,
  DeleteBidReportMutationVariables,
} from "../../../../generated/app-service-gql/graphql";
import { BidReportType } from "../../../../types/graphQLEnums";
import { useGraphQlMutation } from "../../useGraphQlClient";
import { updateBidQuery } from "../bids/updateBidCache";

const deleteBidReport = graphql(`
  mutation deleteBidReport($id: String!) {
    deleteBidReport(id: $id) {
      id
      bidId
      reportType
    }
  }
`);

export function useDeleteBidReport(
  options?: UseMutationOptions<
    DeleteBidReportMutation,
    unknown,
    DeleteBidReportMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(deleteBidReport, {
    ...options,
    onSuccess: async (data, variables, context) => {
      const { id, bidId, reportType } = data.deleteBidReport;
      await queryClient.invalidateQueries({
        queryKey: ["bidReport", id],
      });

      if (bidId) {
        updateBidQuery(queryClient, bidId, (prevData) => {
          if (!prevData) return prevData;

          if (reportType === BidReportType.RequirementSummary) {
            return {
              ...prevData,
              bidReport: null,
            };
          } else {
            return {
              ...prevData,
              qualificationReport: null,
            };
          }
        });
      }
      options?.onSuccess?.(data, variables, context);
    },
  });
  return { data: data?.deleteBidReport, ...rest };
}
